// extracted by mini-css-extract-plugin
export default {"box":"styles_box__1V0CP"};